module.exports = __webpack_public_path__ + "expedition.png?a3a5bd6341d98d2a30839c9f62a777e3";